import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import { useSelector } from "react-redux";
import Navbar from "../components/Navbar";
import reducer from "../reducer";

const DataRow = (props) => {
  const { id, category, title, content, datime, onMarkRead, isRead } = props;

  const handleClick = () => {
    if (!isRead) {
      onMarkRead(id, category);
    }
  };

  const showNewBadge = category === "系统推送" && !isRead;

  return (
    <div
      className={`card border-0 p-3 user-radius mb-2 mt-2 ${isRead ? "bg-light" : ""}`}
      onClick={handleClick}
      style={{ cursor: isRead ? "default" : "pointer", opacity: isRead ? 0.6 : 1 }}
    >
      <div className="row">
        <div className="col">
          <div className="pull-left">
            <strong>
              {"系统消息" === category ? (
                <span className="badge bg-success">{category}</span>
              ) : (
                <span className="badge bg-info">{category}</span>
              )}
              {title}
            </strong>
          </div>
          <br />
          <span>{content}</span>
          <br/>{showNewBadge && <span className="bg bg-warning ms-2 px-1 pb-1" style={{ fontSize: 10 }}>标记为已读</span>}
          {"系统消息" === category ? (
            <div className="d-flex justify-content-end">
              <span className="text-muted">{moment(datime).format("YYYY-MM-DD")}</span>
            </div>
          ) : (
            <div className="d-flex justify-content-end align-items-center">
              <span className="text-muted me-2">{moment(datime).format("YYYY-MM-DD")}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

DataRow.propTypes = {
  category: PropTypes.string.isRequired,
  datime: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onMarkRead: PropTypes.func.isRequired,
  isRead: PropTypes.bool.isRequired,
};

const STORAGE_KEY = "sysMessage_read_ids";

export default function SysMessage() {
  const [state, dispatch] = React.useReducer(reducer, {
    SERVICE_MESSAGE_LIST: [],
    BULLETIN_LIST: [],
    LIST: [],
    PROGRESS: 0,
  });
  const [readIds, setReadIds] = React.useState([]);

  const auth = useSelector((state) => state.auth);

  const handleLogIn = async () => {
    location.href = "#/登录?id=1";
  };

  const getReadIds = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  };

  const markAsRead = (id, category) => {
    const newReadIds = [...readIds, id];
    setReadIds(newReadIds);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newReadIds));
    } catch (e) {
      console.error("Failed to save to localStorage:", e);
    }
  };

  React.useEffect(() => {
    setReadIds(getReadIds());
  }, []);

  React.useEffect(() => {
    if (0 === state.PROGRESS) {
      const url = [
        "/api/miscellaneous/message",
        "?option=by-ref_id2-category-tag-status",
        `&ref_id2=${auth.id}`,
        "&tag=个人用户",
        "&category=系统消息",
        "&status=",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          dispatch({
            type: "set",
            payload: {
              key: "SERVICE_MESSAGE_LIST",
              value: data.map((c) =>
                Object.assign({
                  id: c.id,
                  category: c.category,
                  title: c.title,
                  content: c.content,
                  datime: c.dtime,
                }),
              ),
            },
          });
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
          });
        });
    } else if (1 === state.PROGRESS) {
      fetch("/api/bulletin?option=bulletin-by-tag&tag=个人用户")
        .then((response) => response.json())
        .then((data) => {
          dispatch({
            type: "set",
            payload: {
              key: "BULLETIN_LIST",
              value: data.map((c) =>
                Object.assign({
                  id: c.id,
                  category: "系统推送",
                  title: c.title,
                  content: c.content,
                  datime: c.dday,
                }),
              ),
            },
          });
          dispatch({
            type: "set",
            payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
          });
        });
    } else if (2 === state.PROGRESS) {
      const a = state.SERVICE_MESSAGE_LIST.concat(state.BULLETIN_LIST);
      a.sort((a, b) => {
        if (a.datime < b.datime) return 1;
        if (a.datime > b.datime) return -1;
        return 0;
      });
      dispatch({ type: "set", payload: { key: "LIST", value: a } });
      dispatch({
        type: "set",
        payload: { key: "PROGRESS", value: state.PROGRESS + 1 },
      });
    } else if (state.PROGRESS === 3) {
      const ids = state.SERVICE_MESSAGE_LIST.map((current) => current.id).join(",");
      const timer = window.setTimeout(() => {
        fetch(`/api/miscellaneous/message/${auth.id}?option=status-by-id_list`, {
          method: "PUT",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            id_list: ids,
            status: "已读",
          }),
        });
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [state.PROGRESS]);

  return (
    <>
      {0 === auth.id ? (
        <div className="container-fluid">
          <div className="chat-login">
            <h6>登录后可以查看系统消息</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ fontSize: 14 }}>
          {state.PROGRESS > 1 &&
          state.SERVICE_MESSAGE_LIST.length === 0 &&
          state.BULLETIN_LIST.filter((c) => !readIds.includes(c.id)).length === 0 ? (
            <div className="chat-login">
              <h6>您还没有新的系统消息</h6>
              {readIds.length > 0 && (
                <small className="text-muted">已有 {readIds.length} 条已读推送</small>
              )}
            </div>
          ) : (
            <div>
              {state.PROGRESS > 1 &&
                0 < state.LIST.length &&
                state.LIST
                  .filter((c) => c.category !== "系统推送" || !readIds.includes(c.id))
                  .map((c) => (
                    <DataRow
                      key={c.id}
                      id={c.id}
                      title={c.title}
                      content={c.content}
                      category={c.category}
                      datime={c.datime}
                      onMarkRead={c.category === "系统推送" ? markAsRead : () => {}}
                      isRead={c.category === "系统推送" ? readIds.includes(c.id) : false}
                    />
                  ))}
            </div>
          )}
        </div>
      )}
      <Navbar category="我的" />
    </>
  );
}
